import "./tribunal-etica.scss";

export default function TribunalEtica() {
  return (
    <section id="tribunal-etica" className="section te-page">
      <div className="container section-title fade-up text-center mb-5">
        <h2>Tribunal de Ética y Disciplina</h2>
        <p>
          Órgano responsable de velar por el cumplimiento del Código de Ética
          profesional en el ejercicio de la fonoaudiología en La Pampa.
        </p>
      </div>

      <div className="container fade-up">
        <div className="te-table-wrap">
          <table className="te-table">
            <tbody>
              <tr className="te-table__subheader">
                <td colSpan={2}>
                  <i className="bi bi-shield-check"></i> Conducción
                </td>
              </tr>
              <tr>
                <td className="te-table__cargo">Presidente</td>
                <td className="te-table__nombre">Zaffrani, Adriana</td>
              </tr>

              <tr className="te-table__subheader">
                <td colSpan={2}>
                  <i className="bi bi-people-fill"></i> Vocales Titulares
                </td>
              </tr>
              <tr>
                <td className="te-table__cargo">Vocal Titular</td>
                <td className="te-table__nombre">Vallejo, Valeria</td>
              </tr>
              <tr>
                <td className="te-table__cargo">Vocal Titular</td>
                <td className="te-table__nombre">Fernandez, Silvia</td>
              </tr>

              <tr className="te-table__subheader">
                <td colSpan={2}>
                  <i className="bi bi-person-lines-fill"></i> Vocales Suplentes
                </td>
              </tr>
              <tr>
                <td className="te-table__cargo">Vocal Suplente</td>
                <td className="te-table__nombre">Kolman, Lorena</td>
              </tr>
              <tr>
                <td className="te-table__cargo">Vocal Suplente</td>
                <td className="te-table__nombre">Azcárate, Florencia</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
